import o from "@mui/joy/AutocompleteListbox";
import { withBaseSelectListBoxStyle as t } from "./BaseSelect.js";
const e = t(o);
export {
  e as BaseAutocompleteListbox
};
//# sourceMappingURL=BaseAutocompleteListbox.js.map
